/** Notifyer × Monday guides (authorization, WhatsApp, chat overview). */

export const NOTIFYER_MONDAY_DOCS_OVERVIEW_URL =
  "https://docs.whatsable.app/guides/notifyer-system/monday-overview";

export const NOTIFYER_MONDAY_OVERVIEW_VIDEO_URL =
  "https://www.youtube.com/watch?v=3cc4uvtF7AY";
